import React from "react";
import RpMUIDialog from "@/components/modals/RpMUIModal";
import RpVirtualList from "@/components/virtual/RpVirtualList";
import emailAddresses from "@/features/campaigns/email/utils/emailAddressDummy";

const EmailListModal = ({
  open,
  onClose,
  customerListName,
  heading = "Email List",
}: {
  open: boolean;
  onClose: () => void;
  customerListName?: string;
  heading?: string;
}) => {
  return (
    <RpMUIDialog open={open} onClose={onClose} heading={heading} maxWidth="sm">
      <div className="p-3">
        <div className="mb-3">
          <div
            className="d-inline-block px-3 py-2 fw-b"
            style={{
              backgroundColor: "var(--primary-tint)",
              color: "var(--primary-base)",
              borderRadius: "var(--radius-round)",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {customerListName || "Customers With 500+ Points"}
          </div>
        </div>

        {/* Email List */}
        <div
          style={{
            height: "600px",
            overflow: "hidden",
          }}
        >
          <RpVirtualList
            items={emailAddresses}
            renderItem={(email: string, index: number) => (
              <div
                key={index}
                className="px-3 py-2 table-cell"
                style={{
                  fontSize: "14px",
                  color: "var(--palette-text-primary)",
                }}
              >
                {email}
              </div>
            )}
            useWindowScroll={false}
          />
        </div>
      </div>
    </RpMUIDialog>
  );
};

export default EmailListModal;
